export default "__VITE_ASSET__DM$sYqbg__"